import React from 'react';
import '../Wireframe/Styles/Banner.scss';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import {ReactComponent as Video} from '../../../Assets/Icons/video.svg';
import image from '../../../Assets/Backgrounds/prototypeBanner.webp';
const Banner=()=>{
    return(
        <div className="wireframe-banner">
            <div className="content">
                <h1>The only prototyping tool you need to bring your designs to life</h1>
                <p>Ideate and collaborate on website prototypes with team and clients</p>
            </div>
            <img src={image} />
        </div>
    )
};
export default Banner ;